// Customer Management Permissions

export const CUSTOMERS_INDEX = 9;
export const CUSTOMERS_SHOW = CUSTOMERS_INDEX;
export const CUSTOMERS_CREATE = 10;
export const CUSTOMERS_EDIT = 11;
export const CUSTOMERS_DELETE = 12;
export const CUSTOMERS_PROMOTIONS_CREATE = 122;
export const CUSTOMERS_RESTORE = 1374;

// Quick-create customer (inline "+ Quick add" flow in the invoice / credit-note /
// financial-voucher issuance screens). Gates the quick-add trigger on those screens.
// customers.quick_create — central permission id (backend key: quick_create_customer)
// Quick-add is the same capability as create, with fewer fields.
export const CUSTOMERS_QUICK_CREATE = CUSTOMERS_CREATE;
